import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-vive-ribbon-icon-cell-renderer',
  templateUrl: './vive-ribbon-icon-cell-renderer.component.html',
  styleUrl: './vive-ribbon-icon-cell-renderer.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ViveRibbonIconCellRendererComponent {
  constructor() {}

  params!: ICellRendererParams;

  rating: number = 0;

  formatRating(params: ICellRendererParams) {
    this.params = params;

    const { data } = this.params;

    const { ['spotlightVendorPriorityLevel']: rating } = data;

    this.rating = rating;
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.formatRating(params);
  }

  refresh(params: ICellRendererParams) {
    this.formatRating(params);

    return true;
  }
}
